<template>
  <div id="cL" class="md-layout">
    <div
      v-for="challenge in challenges"
      :key="challenge._id"
      class="md-layout-item md-small-size-50 md-xsmall-size-100 md-size-50"
      @click="redirectTo(challenge._id)"
    >
      <challenge-card card-header="true" class="card">
        <img slot="imageHeader" :src="challenge.titleImage || defaultImage" />
        <div class="h4" slot="title" v-html="challenge.title"></div>
        <span slot="date">
          {{ formatFromToDate(challenge.start, challenge.end) }}
        </span>
        <div
          slot="description"
          v-html="challenge.feedDescription"
          class="description"
        ></div>
      </challenge-card>
    </div>
  </div>
</template>

<script>
import { ChallengeCard } from "@/components";
import datetime from "@/utils/datetime";

export default {
  components: {
    ChallengeCard
  },
  data() {
    return {
      challenges: {},
      challengeCardCss: "md-layout-item md-small-size-100",
      defaultImage: "/img/bg3.jpg"
    };
  },
  mounted() {
    this.$store
    .dispatch("queryAPI", {url: "/rest/challenge/public/"})
    .then(data => {
      this.challenges = data;
      // if(this.challenges.length > 2) {
      //   this.challengeCardCss =+ " md-medium-size-50 md-size-33"
      // } else if(this.challenges.length > 1) {
      //   this.challengeCardCss =+ " md-small-size-50"
      // }
    });
  },
  methods: {
    ...datetime,
    redirectTo(id) {
      this.$router.push("/publicChallengeDetails/" + id);
    }
  }
};
</script>
